<template>
  <div class="bg-white m-3 rounded-md p-3">
    <div class="bg-white m-2 rounded-md">
      <div class="">
        <el-tabs type="border-card">
          <el-tab-pane
            v-for="(tab, index) in filteredTabs"
            :key="index"
            :label="tab.name"
          >
            <div
              v-if="index === 0 && getUserRole.toLowerCase() === 'hrmanager'"
            >
              <LeaveInfoCard :data="[]" :title="title"></LeaveInfoCard>
            </div>
            <div
              v-if="index === 1 && getUserRole.toLowerCase() === 'hrmanager'"
            >
              <LeaveBalances :data="[]" :title="title"></LeaveBalances>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import LeaveInfoCard from "../leaveInfoCard.vue";
import LeaveBalances from "@/components/balances/leaveBalances.vue";
import { mapGetters } from "vuex";

export default {
  name: "Leaves",
  components: { LeaveInfoCard, LeaveBalances },
  data() {
    return {
      currentEmployeeLeaveTypes: [],
      selectedLeaveWorkflow: null,
      leaveWorkflows: [],
      title: "Manage Leave Types",
      tabs: [
        {
          name: "Leave Types Management",
          route: "leave-types-management",
        },
        {
          name: "Leave Balances",
          route: "leave-balances",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getUserRole",
      "getCurrentEmployeeId",
    ]),
    filteredTabs() {
      if (this.getUserRole.toLowerCase() === "hrmanager") {
        return this.tabs;
      } else {
        return this.tabs.filter((tab) => tab.name !== "Leave Types Management");
      }
    },
  },
  created() {},

  methods: {},
};
</script>
